import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { AssignKnowledgeBaseList } from 'src/pages/ControlDeskPage/DataSourceSection/KnowledgeBases/AssignKnowledgeBasePopup/AssignKnowledgeBaseList';
import { CreateEditAiKnowledgeBaseModal } from 'src/pages/AIKnowledgeBasePage/CreateEditAiKnowledgeBase/CreateEditAiKnowledgeBaseModal';
import { Button } from 'src/components/ui/button';
import { clsx } from 'clsx';
import { useAppSelector } from 'src/store';
import { useParams } from 'react-router-dom';
import { useGetProjectByIdQuery } from 'src/services';
import type { KnowledgeBase } from 'src/services/knowledgeBaseService';

export const AssignKnowledgeBasePopup = ({
  trigger,
  disabled = false,
  knowledgeBases = undefined,
}: {
  trigger?: React.ReactNode;
  disabled?: boolean;
  knowledgeBases?: KnowledgeBase[];
}) => {
  const [open, setOpen] = useState(false);
  const { isInactivePlan } = useAppSelector((s) => s.planSlice);
  const { id } = useParams();
  const { data: currentProject } = useGetProjectByIdQuery({ id: id });

  return (
    <Dialog onOpenChange={setOpen} open={disabled ? false : open}>
      <DialogTrigger disabled={disabled} asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Update connected knowledge bases</DialogTitle>
        </DialogHeader>
        <div className="grid gap-8 py-4">
          <AssignKnowledgeBaseList knowledgeBases={knowledgeBases} />
          <div className={'flex flex-row justify-between px-4'}>
            <p className={'font-bold text-ebony text-sm leading-5 select-none'}>
              Create new knowledge base
            </p>
            <CreateEditAiKnowledgeBaseModal
              disabled={isInactivePlan}
              trigger={
                <Button disabled={!currentProject?.is_active || isInactivePlan}>
                  <p className={clsx('font-medium text-sm min-w-24')}>Create</p>
                </Button>
              }
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
